import {DateTime} from 'luxon';
import ObjectStatus from '../enums/static/ObjectStatus';
import {MappingRule} from '../../components/CLRulesMapping/CLRulesMapping.types';
import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';

export interface RemoteDataSource {
  id: number;
  clientId: number;
  name: string;
  isDefault: boolean;
  creation: string;
  status: ObjectStatus;
  type: DataSourceType;
  partnerId?: number;
  partnerName?: string;
  cid: string;
  dsid: string;
  parameters?: {
    mappings?: DataSourceMapping[];
    accountId?: number;
    s3FilesPath?: string;
  };
  partnerLogo: string;
  attributions: string[];
  schedule: DataSourceSchedule;

  // Additional configurations
  dateFormat?: string;
  numberLocalization?: string;
  subjectIdentifiers?: string[];
  productType?: number;
}

export type DataSource = Omit<RemoteDataSource, 'creation'> & {
  creation: DateTime;
  isActive: boolean;
};

export interface PixelItem {
  count: number;
  isRequired: boolean;
}

export interface PixelData {
  eventToParametersRecievedCounts: Record<string, Record<string, PixelItem>>;
  timeToEventCountDic: Record<string, Record<string, number>>;
  pixelId: string;
  name: string;
  eventToCountDic: Record<string, number>;
  timeToTotalEventDic: Record<string, number>;
  totalEventCount: number;
}

export interface RemoteDataSourceStatistics {
  countPerEventType: Record<string, number>;
  date: string;
  datasourceId: number;
  totalCount: number;
  name: string;
  timeToEventCountDic: Record<string, Record<string, number>>;
  timeToTotalEventDic: Record<string, number>;
  eventToParametersRecievedCounts: Record<string, Record<string, PixelItem>>;
}

export type DataSourceStatistics = Omit<RemoteDataSourceStatistics, 'date'> & {
  date: DateTime | null;
};

export enum DataSourceSchedule {
  None = 0,
  Daily = 1,
  Weekly = 2,
}
export interface AddDataSourceParams {
  name: string;
  type: DataSourceType;
  partnerId?: number;
  schedule?: DataSourceSchedule;
  dateFormat?: string;
  numberLocalization?: string;
  subjectIdentifiers?: string[];
  productType?: number;
}

export interface DataSourceHealthReportJobParams {
  dataSourceId: number;
  date: DateTime;
  reportContent: DataSourceJobType;
}

export enum DataSourceType {
  Other = 0,
  WebsitePixels = 10,
  AppEvents = 20,
  DataManagementPlatform = 30,
  CustomerDataPlatform = 40,
  AttributionProvider = 50,
  ExternalAggregatedData = 60,
  OfflineEvents = 70,
}

export interface DatasourceRuleValue {
  value: string;
  uiName: string;
  type: string;
}

export interface DatasourceRuleOption extends DatasourceRuleValue {
  optionalValues?: DatasourceRuleValue[];
}

export interface DataSourceMappingSource {
  type: string;
  key: string;
  jsonPath: string;
}

export interface DataSourceMapping {
  source: DataSourceMappingSource;
  rules: MappingRule[];
  targetField: string;
}

export enum DataSourceJobType {
  DataSourceTechnicalJob = 'DataSourceIdentityHealthReportJob',
  DataSourceContentJob = 'DataSourceEtypeHealthReportJob',
}

export interface AdditionalConfigurationParams {
  numberLocalization: CLSelectorOption[];
}

export enum TimeUnitForPixel {
  Hourly = 0,
  Daily = 10,
}
